import { Component } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import SlotService from '../../cart-process/slot.service';
import { DeviceModel } from '../../models/device.model';
import SlotModel from '../../models/slot.model';
import { CommonInfoService } from '../../cart-process/common-info.service';

@Component({
  selector: 'new-offer-details-business-widget',
  templateUrl: './new-offer-details-business-widget.component.html',
})

export class NewOfferDetailsBusinessWidgetComponent {

  public quantityArray: number[] = [];
  public quantityOfDevicesAndAccessories: number;
  public isQuantityOfDevicesAndAccessoriesVisible: boolean = false;

  constructor(
    public slotService: SlotService,
    private notificationProvider: NotificationProviderService,
    private commonInfo: CommonInfoService,
  ) {

    this.notificationProvider.subscribe(
      NotificationProviderTypeEnum.SLOTS_SERVICE,
      (slotService: SlotService) => {
        this.quantityCounterDevicesAndAccessories(slotService);
      })
  }

  public quantityCounterDevicesAndAccessories(slotService: SlotService) {
    this.quantityArray = [];

    slotService.accessories.forEach((accessories: DeviceModel) => {
      this.quantityArray.push(accessories.quantity);
    });

    slotService.slots.forEach((slot: SlotModel) => {
      const device = slot.device as DeviceModel;

      if (device && device.quantity > 0) {
        const quantity: number = device.bundledDevice ? 2 : 1;

        this.quantityArray.push(quantity);
      }
    });

    this.quantityOfDevicesAndAccessories = this.quantityArray.reduce((a, b) => a + b, 0);
    this.isQuantityOfDevicesAndAccessoriesVisible = this.quantityOfDevicesAndAccessories > 0;
  }
}


